import { createRouter, createWebHistory } from "vue-router";
import { storeSys } from "@/stores/sys.js";
// const storeSys = useSysStore(pinia);
import apis from "@/apis/index.js";
import { nextTick } from "vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/Login.vue"), //懶加載
      meta: { auth: false },
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: () => import("../views/Dashboard.vue"),
      children: [
        {
          path: "",
          name: "home",
          component: () => import("../views/pages/Home.vue"),
        },
        {
          path: "products",
          name: "products",
          component: () => import("../views/pages/Products.vue"),
        },
        {
          path: "orders",
          name: "orders",
          component: () => import("../views/pages/Orders.vue"),
        },
        {
          path: "categories",
          name: "categories",
          component: () => import("../views/pages/Categories.vue"),
        },
        {
          path: "payments",
          name: "payments",
          component: () => import("../views/pages/Payments.vue"),
        },
        {
          path: "deliveries",
          name: "deliveries",
          component: () => import("../views/pages/DeliveriesNew.vue"),
        },
        {
          path: "additions",
          name: "additions",
          component: () => import("../views/pages/Additions.vue"),
        },
        {
          path: "gifts",
          name: "gifts",
          component: () => import("../views/pages/Gifts.vue"),
        },
        {
          path: "customers",
          name: "customers",
          component: () => import("../views/pages/Customers.vue"),
        },
        {
          path: "levels",
          name: "levels",
          component: () => import("../views/pages/Levels.vue"),
        },
        {
          path: "credits",
          name: "credits",
          component: () => import("../views/pages/Credits.vue"),
        },
        {
          path: "points",
          name: "points",
          component: () => import("../views/pages/Points.vue"),
        },
        {
          path: "promotions",
          name: "promotions",
          component: () => import("../views/pages/Promotions.vue"),
        },
        {
          path: "menus",
          name: "menus",
          component: () => import("../views/pages/Menus.vue"),
        },
        {
          path: "pages",
          name: "pages",
          component: () => import("../views/pages/Pages.vue"),
        },
        {
          path: "header_footer",
          name: "header_footer",
          component: () => import("../views/pages/HeaderFooter.vue"),
        },
        {
          path: "logos",
          name: "logos",
          component: () => import("../views/pages/Logos.vue"),
        },
        {
          path: "shipping_fee",
          name: "shipping_fee",
          component: () => import("../views/pages/ShippingFee.vue"),
        },
        {
          path: "site_settings",
          name: "site_settings",
          component: () => import("../views/pages/SiteSettings.vue"),
        },
      ],
    },
    {
      path: "/404",
      name: "404",
      component: () => import("../views/Error.vue"),
      meta: { auth: true },
    },
    {
      path: "/:catchAll(.*)", // 此處需特别注意至於最底部
      redirect: "/404",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (storeSys.token === "" || storeSys.lastUser === "") {
    if (localStorage.getItem("token") !== undefined) {
      storeSys.$patch((state) => {
        state.token = localStorage.getItem("token");
        state.lastUser = localStorage.getItem("lastUser");
      });
    }
  }

  if (from.fullPath === "/" && to.fullPath === "/login") {
    if (storeSys.token !== "") {
      next("/dashboard");
    } else {
      clearToken();
      next();
    }
  } else if (from.fullPath.split("/")[1] === "dashboard" && (to.fullPath === "/" || to.fullPath === "/login")) {
    if (storeSys.token !== "") {
      next(false);
    } else {
      clearToken();
      next();
    }
  } else if (from.fullPath === "/login" && to.fullPath.split("/")[1] === "dashboard") {
    if (storeSys.token !== "") {
      await requestData(to);
      next();
    } else {
      clearToken();
      next(false);
    }
  } else {
    if (storeSys.token !== "") {
      await requestData(to);
      next();
    } else {
      clearToken();
      next("/login");
    }
  }
});

function clearToken() {
  storeSys.$patch((state) => {
    state.token = "";
  });
  localStorage.setItem("token", storeSys.token);
}

async function requestData(to) {
  nextTick(() => {
    storeSys.loadingText = "載入中";
    storeSys.loadingScreen = true;
  });

  try {
    switch (to.name) {
      // case "home":
      //   await apis.userdataApi.get();
      //   break;
      // case "categories":
      //   await apis.categoryApi.getAll();
      //   break;
      case "products":
        await apis.productApi.get(to.path, to.query);
        await apis.categoryApi.get();
        break;
      case "categories":
        await apis.categoryApi.get();
        break;
      case "deliveries":
        await apis.deliveryApi.get();
        break;
      case "payments":
        await apis.paymentApi.get();
        break;
      case "gifts":
        await apis.giftApi.get();
        break;
      case "additions":
        await apis.additionApi.get();
        break;
      case "credits":
        await apis.settingApi.getCredits();
        break;
      case "points":
        await apis.settingApi.getPoints();
        break;
      case "levels":
        await apis.levelApi.get();
        break;
      case "customers":
        await apis.customerApi.getAll(to.path, to.query);
        break;
      case "promotions":
        await apis.promotionApi.get(to.path, to.query, "none"); //none 這個參數可以是 shipping_fee 以外的任何字串，如果是 shipping_fee 則會請求運費的優惠活動
        break;
      case "shipping_fee":
        await apis.promotionApi.get(to.path, to.query, "shipping_fee");
        break;
      case "pages":
        await apis.pageApi.get();
        break;
      case "menus":
        await apis.userApi.get();
        await apis.pageApi.get();
        await apis.categoryApi.get();
        break;
      case "logos":
        await apis.settingApi.getLogos();
        break;
      case "site_settings":
        await apis.settingApi.get();
        break;
    }
  } catch (error) {
    console.log(error);
  }

  setTimeout(() => {
    storeSys.loadingText = "";
    storeSys.loadingScreen = false;
  }, 500);
}

function safeJsonParse(value, fallback) {
  if (value === null || value === undefined || value === "") return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.log(error);
    return fallback;
  }
}

export default router;
